import {DiscountType} from "../../../libs/enum/discount-type";

export class InvoiceDiscountDto {

  public id!: string;
  public type!: DiscountType;
  public value!: number;
  public readonly netAmount: number | undefined;
  public readonly grossAmount: number | undefined;
  public readonly vatAmount: number | undefined;
  public readonly totalNetAmount: number | undefined;
  public readonly totalGrossAmount: number | undefined;
  public readonly totalVatAmount: number | undefined;

  constructor(init?: Partial<InvoiceDiscountDto> | undefined) {
    Object.assign(this, init);
  }
}
